import { Component, EventEmitter, Input, Output } from '@angular/core';

export type MessageDialogType = 'success' | 'error' | 'warning' | 'info';

@Component({
  selector: 'app-message-dialog',
  templateUrl: './message-dialog.component.html',
  styleUrl: './message-dialog.component.scss',
})
export class MessageDialogComponent {
  @Input() visible: boolean = false;
  @Input() title: string = '';
  @Input() message: string = '';
  @Input() type: MessageDialogType = 'error';
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() closed = new EventEmitter<void>();

  get titleClass(): string {
    switch (this.type) {
      case 'success':
        return 'text-success';
      case 'error':
        return 'text-danger';
      case 'warning':
        return 'text-warning';
      case 'info':
        return 'text-info';
      default:
        return 'text-danger';
    }
  }

  get iconClass(): string {
    switch (this.type) {
      case 'success':
        return 'pi pi-check-circle text-success';
      case 'error':
        return 'pi pi-times-circle text-danger';
      case 'warning':
        return 'pi pi-exclamation-triangle text-warning';
      case 'info':
        return 'pi pi-info-circle text-info';
      default:
        return 'pi pi-times-circle text-danger';
    }
  }

  closeDialog(): void {
    this.visible = false;
    this.visibleChange.emit(false);
    this.closed.emit();
  }
}
